import React from 'react'
import { useEffect } from 'react'


import Edu from '../Components/Edu'
import Recog from '../Components/Recog'

import Eyes from '../Components/Eyes'

import Info3 from '../Components/Info3'
import UniqueCard from '../Components/UniqueCard'
import Experience from '../Components/Experience'




const About = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);


  return (
  <div className='sm:p-[3vw] p-[4vw]'>
  
  <Eyes/>
  <Info3/>
  <UniqueCard/>
  <Experience/>
 <Edu/>
 <Recog/>
 
  </div>
  )
}

export default About
 